<template>
    <div style="display: inline-block;">
        <span @click.stop="showView">
            <slot></slot>
        </span>

        <el-dialog
            :visible.sync="visible"
            :append-to-body="true"
            :custom-class="$style.dialog"
            title="修改商品"
        >
            <pro-optiont
                :type="1"
                :list="list"
                :rec_id="rec_id"
                :goods_id="goods_id"
                :product_id="product_id"
                :goods_number="goods_number"
                :referer="referer"
                :order_id="order_id"
                :goods_price="goods_price"
                :getCartProducts="getCartProducts"
                :fang = "fang"
                :visible.sync="visible"
                :goods_attr_list="goods_attr_list"
                :goods_attr_id="goods_attr_id"
                :getOrderList="getOrderList"
                :order_sn="order_sn"
            ></pro-optiont>
        </el-dialog>
    </div>
</template>
<script>
    import Vue from 'vue';
    import ProOptionst from './ProOptionst.vue';

    Vue.component('pro-optiont', ProOptionst);

    export default {
        props: ['goods_attr_list', 'goods_id', 'rec_id', 'referer', 'order_id', 'goods_price', 'goods_attr_id', 'product_id', 'getCartProducts', 'goods_number', 'getOrderList', 'order_sn'],

        data () {
            return {
                visible: false,
                list: []
            };
        },
        created() {
            // console.log(this.goods_id);
        },
        methods: {
            showView() {
             this.visible = true
             this.list = (this.goods_attr_list || []).map(item => ({...item}))
            }
        },
    };
</script>

<style lang="less" module>
    .dialog {
        width: 600px;
        :global(.el-dialog__header) {
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #C7C7C7;
        }
        :global(.el-dialog__body) {
            padding: 30px 90px 30px 70px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/OrderList/Dialogs.vue